import React, { AnchorHTMLAttributes, useCallback } from 'react'
import classNames from 'classnames'

import { ExternalLink } from '../../../global/ExternalLink'
import { NavigationArrowRightDiagonalIcon } from '../../../icons/NavigationArrowRightDiagonalIcon'
import { TextStrong } from '../../Typography/Typography'

import styles from './DocumentLink.module.scss'

export interface DocumentLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  title: string
  to?: string
  disabled?: boolean
}

export const DocumentLink: React.FC<DocumentLinkProps> = (props) => {
  const { title, to, disabled, onClick, ...restProps } = props

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (disabled) {
        event.preventDefault()
        return
      }
      onClick?.(event)
    },
    [onClick, disabled]
  )

  return (
    <ExternalLink
      url={to}
      onClick={handleClick}
      {...restProps}
      className={classNames(styles.link, {
        [styles.disabled]: disabled,
      })}
    >
      <span className={styles.title}>
        <TextStrong>{title}</TextStrong>
      </span>
      <span className={styles.icon}>
        <NavigationArrowRightDiagonalIcon size={32} />
      </span>
    </ExternalLink>
  )
}
